/**
 * @generated SignedSource<<684a809e96981943759baaef3566491f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraIssueLinkDirection = "INWARD" | "OUTWARD" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView$data = {
  readonly fieldId: string;
  readonly id: string;
  readonly issueLink: {
    readonly direction: JiraIssueLinkDirection | null | undefined;
    readonly id: string | null | undefined;
    readonly relationName: string | null | undefined;
    readonly type: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"ui_JiraIssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView">;
  readonly " $fragmentType": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView";
};
export type ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView$key = {
  readonly " $data"?: ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraIssueLink",
      "kind": "LinkedField",
      "name": "issueLink",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "direction"
        },
        {
          "kind": "ScalarField",
          "name": "relationName"
        },
        {
          "concreteType": "JiraIssueLinkType",
          "kind": "LinkedField",
          "name": "type",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_JiraIssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView"
    }
  ],
  "type": "JiraIssueLinkRelationshipTypeField"
};
})();

(node as any).hash = "ab55fe82c13f74f06fd5d284a97d55e1";

export default node;
